import React, { useEffect, useMemo, useState } from "react";
import "./MyCard.css";

export default function MyCard() {
  const slides = useMemo(
    () => [
      {
        id: 1,
        bg: "linear-gradient(135deg, #f9e6c4 0%, #f6d9b4 45%, #f3cfae 100%)",
        titleTop: "Sites Vitrines",
        titleBold: "Parlez de vous.",
        subtitle: "Nous aidons les entreprises à se démarquer grâce à des sites vitrines élégants, rapides et stratégiquement conçus pour inspirer confiance et soutenir leur croissance.",
        cta: "Prendre un rendez-vous",
        // Image type "legs shoes" (tu peux remplacer par la tienne)
        heroImg:
          "/site1.webp",
        thumbs: [
          "/site1.webp",
          "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=220&q=80",
          "https://images.unsplash.com/photo-1520256862855-398228c41684?auto=format&fit=crop&w=220&q=80",
        ],
      },
      {
        id: 2,
        bg: "linear-gradient(135deg, #e9f7f1 0%, #d6f1e6 55%, #c9ecd9 100%)",
        titleTop: "Sites Ecommerce",
        titleBold: "Boostez vos ventes.",
        subtitle: "Nous concevons des sites e-commerce performants et sécurisés, pensés pour développer vos ventes en ligne et simplifier la gestion de votre activité. Nos solutions offrent une expérience d’achat fluide, optimisée pour convertir vos visiteurs en clients fidèles.",
        cta: "Prendre un rendez-vous",
        heroImg:
          "/site2.jpg",
        thumbs: [
          "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=220&q=80",
          "https://images.unsplash.com/photo-1528701800489-20be9c5f7b83?auto=format&fit=crop&w=220&q=80",
          "https://images.unsplash.com/photo-1520256862855-398228c41684?auto=format&fit=crop&w=220&q=80",
        ],
      },
      {
        id: 3,
        bg: "linear-gradient(135deg, #fde6e6 0%, #f9d1d1 55%, #f4c1c1 100%)",
        titleTop: "Gestion de Stock.",
        titleBold: "Optimisez votre stock",
        subtitle: "Un outil de gestion de stock vous permet de garder une visibilité complète et en temps réel sur vos produits. Nous mettons en place des solutions fiables qui réduisent les ruptures, optimisent les coûts et améliorent la performance globale de votre activité.",
        cta: "Prendre un rendez-vous",
        heroImg:
          "/site3.jpg",
        thumbs: [
          "https://images.unsplash.com/photo-1520256862855-398228c41684?auto=format&fit=crop&w=220&q=80",
          "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=220&q=80",
          "https://images.unsplash.com/photo-1528701800489-20be9c5f7b83?auto=format&fit=crop&w=220&q=80",
        ],
      },
    ],
    []
  );

  const [index, setIndex] = useState(0);

  const prev = () => setIndex((p) => (p - 1 + slides.length) % slides.length);
  const next = () => setIndex((p) => (p + 1) % slides.length);

  // Autoplay (comme un vrai carousel)
  useEffect(() => {
    const t = setInterval(() => {
      setIndex((p) => (p + 1) % slides.length);
    }, 5000);
    return () => clearInterval(t);
  }, [slides.length]);

  const active = slides[index];

  return (
    <section className="mtghWrap-mtgh">
      <div className="mtghInner-mtgh">
        <div className="carouselShell-mtgh">
          <div className="carouselCard-mtgh" style={{ background: active.bg }}>
            {/* flèches */}
            <button className="arrowBtn-mtgh arrowLeft-mtgh" onClick={prev} aria-label="Previous">
              <span className="arrowIcon-mtgh">←</span>
            </button>
            <button className="arrowBtn-mtgh arrowRight-mtgh" onClick={next} aria-label="Next">
              <span className="arrowIcon-mtgh">→</span>
            </button>

            {/* contenu */}
            <div className="cardGrid-mtgh">
              {/* LEFT */}
              <div className="leftBlock-mtgh">
                <h3 className="title-mtgh">
                  <span className="titleLight-mtgh">{active.titleTop}</span>
                  <br />
                  <span className="titleBold-mtgh">{active.titleBold}</span>
                </h3>

                <p className="subtitle-mtgh">{active.subtitle}</p>

                <a className="ctaBtn-mtgh" href="https://wa.me/+22893410827" style={{textDecoration: 'none'}}>
                  {active.cta}
                  <span className="ctaArrow-mtgh" aria-hidden="true">
                    →
                  </span>
                </a>
              </div>

              {/* RIGHT IMAGE */}
              <div className="rightBlock-mtgh" aria-hidden="true">
                <img className="heroImg-mtgh" src={active.heroImg} alt="" />
              </div>
            </div>

            {/* thumbnails bas-centre */}
            {/* <div className="thumbsRow-mtgh" aria-label="Carousel thumbnails">
              {active.thumbs.slice(0, 3).map((t, i) => (
                <button
                  key={t + i}
                  className={`thumbBtn-mtgh ${i === 0 ? "thumbActive-mtgh" : ""}`}
                  onClick={() => {
                    // option : cliquer une thumb = aller au slide correspondant (simple mapping)
                    // ici on utilise i pour naviguer relative
                    setIndex((index + i) % slides.length);
                  }}
                  aria-label={`Thumbnail ${i + 1}`}
                >
                  <img className="thumbImg-mtgh" src={t} alt="" />
                </button>
              ))}
            </div> */}

            {/* petite barre (comme sur l’image) */}
            <div className="progressTrack-mtgh" aria-hidden="true">
              <span className="progressBar-mtgh" style={{ width: `${((index + 1) / slides.length) * 100}%` }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
